import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'

class DecimalValueAndUnit implements IDecimalValueAndUnit {
  value: number

  unit: string

  constructor(item?: any) {
    this.value = item?.value ?? null
    this.unit = item?.unit ?? null
  }
}

export default DecimalValueAndUnit
